"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeatureBulletsStateFromVariation = exports.getPriceHydratorStateFromVariation = exports.getVariationValuesFromAsin = exports.getAsinFromClick = exports.getAsinFromVariation = void 0;
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const getAsinFromVariation = (variationMap, values) => {
    const variationEntry = Object.entries(variationMap).find(([_productAsin, variation]) => {
        return (0, isEqual_1.default)(values, variation.variationIndex);
    });
    return variationEntry ? variationEntry[0] : undefined;
};
exports.getAsinFromVariation = getAsinFromVariation;
const getAsinFromClick = (variationMap, dimensionKeyIndex, dimensionValueIndex) => {
    const variationEntry = Object.entries(variationMap).find(([_productAsin, variation]) => {
        return variation.variationIndex[dimensionKeyIndex] === dimensionValueIndex;
    });
    return variationEntry ? (0, exports.getAsinFromVariation)(variationMap, variationEntry[1].variationIndex) : undefined;
};
exports.getAsinFromClick = getAsinFromClick;
const getVariationValuesFromAsin = (variationMap, asin) => {
    var _a;
    return (_a = variationMap[asin]) === null || _a === void 0 ? void 0 : _a.variationIndex;
};
exports.getVariationValuesFromAsin = getVariationValuesFromAsin;
const getPriceHydratorStateFromVariation = (variationMap, values) => {
    const variation = Object.values(variationMap).find((variation) => {
        return (0, isEqual_1.default)(values, variation.variationIndex);
    });
    return variation ? variation.priceState : undefined;
};
exports.getPriceHydratorStateFromVariation = getPriceHydratorStateFromVariation;
const getFeatureBulletsStateFromVariation = (variationMap, values) => {
    const variation = Object.values(variationMap).find((variation) => {
        return (0, isEqual_1.default)(values, variation.variationIndex);
    });
    return variation ? variation.featureBulletsState : undefined;
};
exports.getFeatureBulletsStateFromVariation = getFeatureBulletsStateFromVariation;
__exportStar(require("./desktop"), exports);
__exportStar(require("./plus"), exports);
